import clsx from 'clsx'
import Image from 'next/image'

import { STATIC_URL } from 'constants/data'
import { onboardingConfig } from './data'

import styles from './landing-profit.module.scss'
import commnomStyle from '../landing-common.module.scss'

const LangingProfit = () => {
  return (
    <div className={commnomStyle.section}>
      <h2 className={clsx(commnomStyle.h2, styles.title)}>Как AI Bolit может вам помочь?</h2>
      <div className={styles.cardWrapper}>
        {onboardingConfig.map((card, index) => {
          const slideNum = index + 1
          return (
            <div key={index} className={clsx(styles.card, card.cardClass)}>
              <div className={styles.cardTitle}>{card.title}</div>
              <div className={styles.cardText}>{card.text}</div>
              <div className={card.imgClass}>
                <Image
                  src={`${STATIC_URL}/ai-bolit/profit-${slideNum}.png`}
                  width={card.imgWidth}
                  height={card.imgHeight}
                  unoptimized
                  alt={card.imgAlt}
                />
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default LangingProfit
